import { useState, useEffect, useCallback } from "react";
import {
  fetchShops as apiFetchShops,
  updateShop as apiUpdateShop,
} from "../services/shopsService";

// Хук керує станом та логікою для налаштувань магазинів
const useShops = () => {
  const [shops, setShops] = useState([]);

  // Завантажує список магазинів з сервера
  const fetchData = useCallback(async () => {
    try {
      const data = await apiFetchShops();
      setShops(data);
    } catch (err) {
      console.error("Помилка завантаження магазинів:", err);
    }
  }, []);

  // Ефект для початкової ініціалізації при першому завантаженні сторінки
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Оптимістично оновлює дані одного магазину
  const updateShop = useCallback(
    async (shopId, fields) => {
      try {
        await apiUpdateShop(shopId, fields);
        setShops((prev) =>
          prev.map((shop) => (shop.id === shopId ? { ...shop, ...fields } : shop))
        );
      } catch (err) {
        console.error(`Помилка оновлення магазину з id ${shopId}:`, err);
      } finally {
        fetchData();
      }
    },
    [fetchData]
  );

  return { shops, refresh: fetchData, updateShop };
};

export default useShops;